import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TypeaheadProvider from 'app/common/lib/TypeaheadProvider';

export default class Typeahead extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    onTypeaheadSuggestionsChange: PropTypes.func.isRequired,
    resourceName: PropTypes.string.isRequired,
    shouldCacheEmptyQuery: PropTypes.bool,
    value: PropTypes.string.isRequired,
  };

  static defaultProps = {
    resourceName: 'TypeaheadResource',
    shouldCacheEmptyQuery: false,
  };

  constructor(props, context) {
    super(props, context);
    const { shouldCacheEmptyQuery } = this.props;
    if (shouldCacheEmptyQuery) {
      this.searchCache[''] = null;
    }
  }

  componentDidMount() {
    this.provider = new TypeaheadProvider({
      resource_name: this.props.resourceName,
    });
  }

  UNSAFE_componentWillReceiveProps({ value }) {
    if (value !== undefined && value !== null && value !== this.props.value) {
      this.search(value);
    }
  }

  searchCache = Object.create(null);

  search = (query) => {
    if (query in this.searchCache) {
      this.props.onTypeaheadSuggestionsChange(this.searchCache[query]);
    } else {
      this.provider.search(query, ({ items }) => {
        this.searchCache[query] = items;
        this.props.onTypeaheadSuggestionsChange(items);
      });
    }
  };

  render() {
    return <div className={this.props.className}>{this.props.children}</div>;
  }
}
